import { addHandlerClickOnCompareIcon } from './compare';

const disableButton = (btn) => {
  if (btn) {
    btn.classList.add('disabled');
    btn.querySelector('span').innerText = 'Загрузка';
  }
};

const fetchMoreItems = async (data) => {
  const formData = new FormData();
  const keys = Object.keys(data);
  keys.forEach((key) => {
    formData.append(`${key}`, data[key]);
  });

  const formatedData = new URLSearchParams(formData);

  try {
    const rawResponse = await fetch(
      window.location.href,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formatedData,
      },
    );

    const responseToString = await rawResponse.text();
    return responseToString;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return null;
  }
};

const initNewNodes = () => {
  queueMicrotask(() => {
    window.initBuyScript(true);
    addHandlerClickOnCompareIcon(true);
    window.addHandlerClickOnFavoriteIcon(true);
    window.lazyUpdate();
    window.initShowMoreScript();
    window.loyaltyProgramInit();
  });
};

const showMoreListener = async (evt) => {
  const target = evt.target.classList.contains('_show-more')
    ? evt.target
    : evt.target.closest('._show-more');

  const { attributes } = target;
  const pagenKey = attributes['data-pagen-key'].value;
  const pagenValue = attributes['data-pagen-value'].value;

  const data = {};
  data.action = 'showMore';
  data[`PAGEN_${pagenKey}`] = pagenValue;

  disableButton(target);
  const result = await fetchMoreItems(data);

  if (result) {
    const htmlResponseWrapper = document.createElement('div');
    htmlResponseWrapper.innerHTML = result;

    const catalogView = window.localStorage.getItem('catalogSwitch');
    if (catalogView === 'list') {
      const newItems = htmlResponseWrapper.querySelectorAll('.product-card');
      newItems.forEach((item) => item.classList.add('product-card--row'));
    }

    const paginationNode = document.querySelector('[data-pagination-num]');
    const newPaginationNode = htmlResponseWrapper.querySelector('[data-pagination-num]');
    if (paginationNode && newPaginationNode) paginationNode.parentNode.replaceChild(newPaginationNode, paginationNode);

    const newShowMoreButton = htmlResponseWrapper.querySelector('._show-more');
    if (newShowMoreButton) target.parentNode.replaceChild(newShowMoreButton, target);
    else target.remove();

    const itemsWrapper = document.querySelector('.catalog-lvl-three__body');
    const newItemsWrapper = htmlResponseWrapper.querySelector('.catalog-lvl-three__body');
    if (itemsWrapper && newItemsWrapper) itemsWrapper.innerHTML += newItemsWrapper.innerHTML;

    initNewNodes();
  }
};

const initShowMoreScript = () => {
  const showMoreButton = document.querySelector('[data-pagen-key]');
  if (showMoreButton) {
    showMoreButton.addEventListener('click', showMoreListener);
  }
};

initShowMoreScript();

window.initShowMoreScript = initShowMoreScript;
